import { motion } from "framer-motion";
import { useLanguage } from "../i18n";

const EASE = [0.22, 1, 0.36, 1];

const Manifesto = () => {
  const { t } = useLanguage();
  return (
    <section
      className="relative overflow-hidden bg-[#0D1B2A] py-24 text-[#FAF6F0] sm:py-32"
      data-testid="manifesto-section"
    >
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-24 -top-24 h-96 w-96 rounded-full bg-[#1B6B93]/20 blur-3xl"
      />
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.p
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6, ease: EASE }}
          className="mb-4 text-xs font-semibold uppercase tracking-[0.25em] text-[#F2A33C]"
        >
          {t.manifesto.eyebrow}
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.08, ease: EASE }}
          className="max-w-3xl font-serif text-4xl font-black tracking-tight sm:text-5xl lg:text-6xl"
        >
          {t.manifesto.title}
        </motion.h2>

        <div className="mt-16">
          {t.manifesto.chapters.map((c, i) => (
            <motion.div
              key={c.title}
              data-testid={`manifesto-chapter-${i + 1}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.65, delay: 0.05 * i, ease: EASE }}
              className="group grid grid-cols-12 items-start gap-4 border-t border-white/10 py-9 transition-colors duration-500 hover:bg-white/[0.03] sm:gap-8"
            >
              <span className="col-span-3 font-serif text-5xl font-black italic text-[#F2A33C]/90 transition-transform duration-500 group-hover:translate-x-2 sm:col-span-2 sm:text-6xl lg:text-7xl">
                {String(i + 1).padStart(2, "0")}
              </span>
              <div className="col-span-9 sm:col-span-10 lg:flex lg:items-start lg:gap-12">
                <h3 className="font-serif text-2xl font-bold sm:text-3xl lg:w-2/5">
                  {c.title}
                </h3>
                <p className="mt-2 max-w-xl text-sm leading-relaxed text-[#FAF6F0]/60 sm:text-base lg:mt-1 lg:w-3/5">
                  {c.desc}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.p
          initial={{ opacity: 0, rotate: -4 }}
          whileInView={{ opacity: 1, rotate: -2 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2, ease: EASE }}
          className="mt-12 text-center font-script text-3xl text-[#F2A33C] sm:text-4xl"
        >
          {t.manifesto.note}
        </motion.p>
      </div>
    </section>
  );
};

export default Manifesto;
